(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAddUrl", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                wizard: "="
            },
            templateUrl: "app/learningItems/add/steps/learningItemType/learningItemAddUrlView.html",
            controller: ["$window", LearningItemAddUrlCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddUrlCtrl($window) {
            var vm = this;
            vm.gotoLink = gotoLink;
            vm.selectDisplayMode = selectDisplayMode;
            vm.$onInit = function () {
                initializeDisplayMode();
            };
            ///////////////////////////////////////////////////////////////
            vm.isShown = function (displayOptionMode) {
                return displayOptionMode === vm.wizard.formData.specificInfo.displayOptionMode;
            };
            function initializeDisplayMode() {
                if (!vm.wizard.formData.specificInfo.displayOptionMode)
                    vm.wizard.formData.specificInfo.displayOptionMode = "url";
            }
            function selectDisplayMode(value) {
                vm.wizard.formData.specificInfo.displayOptionMode = value;
            }
            function gotoLink(url) {
                if (url) {
                    if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1 || url.indexOf("ftp") > -1) {
                        $window.open(url, "_blank");
                    }
                    else {
                        vm.wizard.formData.specificInfo.url = "http://" + vm.wizard.formData.specificInfo.url;
                        url = vm.wizard.formData.specificInfo.url;
                        $window.open(url, "_blank");
                    }
                }
                else {
                    vm.wizard.vm.showErrors = true;
                }
            }
        }
    });
}());
